import { create } from "zustand";

const usePopupStore = create((setState) => ({
  popupShown:false,
  languagedropdown:false,
  selectedLangaugeData:{},
  textareaLen:0,
  errormsgdisplay:false,
  // audioclicked:false,
  selectedText:'',
  selectedTextArray:[],
  readValue:true,
  selectedLanguage:false,
  textTranslation:false,
  languageSelected:false,
  selectedLanguageCode:false,
  selectedLanguageTtsSupport:false,
  bookType:'',
  skeleton:false,
  bookType:'',
  setState: setState
}));

export default usePopupStore;
